import { render, staticRenderFns } from "./scancode.vue?vue&type=template&id=652eb943&scoped=true&"
import script from "./scancode.vue?vue&type=script&lang=js&"
export * from "./scancode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../55/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652eb943",
  null
  
)

export default component.exports